import axios from 'axios';
import { api, headers } from '../../app/conf';

export const getTicketsReasonsService = (token) =>
    axios({
        method: 'get',
        url: `${api}/v1/tasksCasesReasons`,
        headers: {
            ...headers,
            'X-Access-Token': token
        }
    })